module.exports = __webpack_public_path__ + "img/concrete_roof_with_bituminous_felt.9cad59ae.jpg";